import { invokeApi } from "src/utils";

export const _login = async (data) => {
  const token = await _generate_token();
  const requestObj = {
    path: `api/app_api/login`,
    method: "POST",
    headers: {
      "x-sh-token": token.token,
    },
    postData: data,
  };
  return invokeApi(requestObj);
};

export const logout = async (data) => {
  const requestObj = {
    path: `api/examplePath`,
    method: "POST",
    headers: {
      // 'x-sh-auth': 1234
    },
    postData: data,
  };
  return invokeApi(requestObj);
};
export const _generate_token = () => {
  const requestObj = {
    path: `api/app_api/send_verification_token`,
    method: "POST",
    postData: { code: "verify" },
  };
  return invokeApi(requestObj);
};

export const _update_user_profile = async (data) => {
  const requestObj = {
    path: `api/admin/edit_admin_profile`,
    method: "PUT",
    headers: {
      "x-sh-auth": localStorage.getItem("token"),
    },
    postData: data,
  };
  return invokeApi(requestObj);
};

export const _change_email = async (data) => {
  const requestObj = {
    path: `api/admin/edit_admin_email`,
    method: "PUT",
    headers: {
      "x-sh-auth": localStorage.getItem("token"),
    },
    postData: data,
  };
  return invokeApi(requestObj);
};

export const _change_password = async (data) => {
  const requestObj = {
    path: `api/app_api/change_password`,
    method: "PUT",
    headers: {
      "x-sh-auth": localStorage.getItem("token"),
    },
    postData: data,
  };
  return invokeApi(requestObj);
};